import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class OrderWithAuthorizationResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'order': {
                    "number": 1,
                    "state": "INITIAL",
                    "customer": {
                        "code": 5,
                        "business_name": 2,
                        "number": 2,
                        "fantasy_name": "Customer",
                        "delivery_sites": [{
                            "name": "Customer Delivery Site",
                            "address": "Address",
                            "city": "City",
                        }],
                    },
                    "delivery_site": {
                        "name": "Customer Delivery Site",
                        "address": "Address",
                        "city": "City",
                    },
                    "delivery_date": "20-05-2024",
                    "observations": "An Observation",
                    "articles": [
                        {
                            'article': {
                                'category': {
                                    'banner_image': '',
                                    'black_logo_image': '',
                                    'description': '',
                                    'main_image': '',
                                    'name': '',
                                    'title': '',
                                    'white_logo_image': ''
                                },
                                'code': 'P.111.01.0104       ',
                                'cooking_temperature': '',
                                'cooking_time': '',
                                'description': '',
                                'fantasy_name': 'ALFAJOR DE VAINILLA Y CHOC BLANCO (CAJA X 126 UN.)',
                                'file': '/invalid_url',
                                'id': 103,
                                'items_amount': '',
                                'items_unit': 'KG',
                                'measures': '',
                                'name': 'ALFAJOR DE VAINILLA Y CHOC BLANCO (CAJA X 126 UN.)',
                                'specification_sheet': 'invalid_url',
                                'weight': ''
                            },
                            'quantity': 9
                        },
                        {
                            // Only if state is INVOICED
                            "article": {
                                "code": "1",
                                "name": "Articulo",
                                "fantasy_name": "Articulo Fantasia",
                                "items_amount": "20",
                                "category": {
                                    "name": "Categoria",
                                    "title": "Titulo Categoria",
                                    "description": "Descripcion Categoria"
                                }
                            },
                            "quantity": 4,
                            "unit_price": {
                                'amount': 60.00,
                                'currency': "ARS"
                            },
                            "price": {
                                'amount': 1200.00,
                                'currency': "ARS"
                            }

                        }
                    ]
                },
                'authorization': {
                    "state": 'PENDING',
                }
            },
            errors: []
        }
    }

    order() {
        return {
            number: this.number(),
            state: this.adaptOrderState(this.state()),
            customer: this.customer(),
            deliverySite: this.deliverySite(),
            deliveryDate: this.deliveryDate(),
            observations: this.observations(),
            articles: this.articles(),
            invoiceNumber: this.invoiceNumber(),
            customersOrderNumber: this.customersOrderNumber()
        }
    }

    number() {
        return this.content().order.number;
    }

    adaptOrderState(orderState) {
        if (orderState === "INITIAL") {
            return "ABIERTO"
        }
        if (orderState === "PENDING") {
            return "CERRADO"
        }
        if (orderState === "CONFIRMED") {
            return "PROCESO DE FACTURACIÓN"
        }
        if (orderState === "INVOICED") {
            return "FACTURADO"
        }
        if (orderState === "FAILED_TO_CONFIRMED") {
            return "FALLO EN TRANSMISIÓN"
        }
        if (orderState === "REVISION") {
            return "EN REVISIÓN"
        }
    }

    state() {
        return this.content().order.state;
    }

    customer() {
        const customer = this.content().order.customer
        return {
            code: customer.code,
            businessName: customer.business_name,
            customerCode: customer.code,
            fantasyName: customer.fantasy_name,
        }
    }

    deliverySite() {
        const deliverySite = this.content().order.delivery_site
        return {
            deliverySiteName: deliverySite.name,
            deliverySiteAddress: deliverySite.location.address,
            deliverySiteCity: deliverySite.location.city,
            deliveryDate: "",
        }
    }

    deliveryDate() {
        return this.content().order.delivery_date
    }

    observations() {
        return this.content().order.observations
    }

    articles() {
        const state = this.content().order.state;

        return this.content().order.articles.map(articleWithAmount => {
                const article =  {
                    code: articleWithAmount.article.code,
                    name: articleWithAmount.article.name,
                    family: articleWithAmount.article.category.title,
                    amount: articleWithAmount.quantity,
                    file: articleWithAmount.article.file,
                    fantasyName: articleWithAmount.article.fantasy_name,
                    itemsAmount: articleWithAmount.article.items_amount,
                    itemsUnit: articleWithAmount.article.items_unit,
                }

                if (state === 'INVOICED') {
                    article.fantasyName = articleWithAmount.article.fantasy_name
                    article.price = articleWithAmount.price
                    article.unitPrice = articleWithAmount.unit_price
                    article.itemPrice = articleWithAmount.unit_price
                }

                return article
            }
        )
    }

    customersOrderNumber() {
        return this.content().order.customers_order_number;
    }

    invoiceNumber() {
        return this.content().order.invoice_number;
    }
}